/** Extrae el grupo de un vínculo módulo-grupo. */
function linkGroup(gm: any): any {
  return gm?.group || null
}

/** Filtra los grupos nulos o indefinidos. */
function validGroups(groups: any[]): any[] {
  return groups.filter(g => !!g)
}

/** Obtiene los enlaces crudos de grupos del módulo. */
function rawLinks(module: any): any[] {
  return (module?.groupModules || []).map(linkGroup)
}

/** Obtiene los grupos válidos del módulo. */
export function moduleGroups(module: any): any[] {
  return validGroups(rawLinks(module))
}
